import { call, fork, put, take } from "redux-saga/effects";

// Actions
import * as actionsCreator from "./reducer";

// Start Sagas
export function* impuritiesForDrugSagaStart(api: any, action: any) {
  yield fork(getProductInfoWatcher, api, action);

  yield fork(getRelatedCompoundsWatcher, api, action);
}

export function* getRelatedCompoundsWatcher(api: any, action: any): Generator<any, void, any> {
  while(true) {
    try {
      const actions = yield take(actionsCreator.getRelatedCompounds.type);

      const res = yield call(api.request, 'ebcCatalogRelatedCompounds', actions.payload);

      if (!res?.ok) {
        yield put(actionsCreator.getRelatedCompoundsError());
      } else {
        yield put(actionsCreator.getRelatedCompoundsSuccess(res.data));
      }
    } catch (e) {
      console.log("CATCH ERROR getRelatedCompoundsWatcher: ", e);
    }
  }
}

export function* getProductInfoWatcher(api: any, action: any): Generator<any, void, any> {
  while (true) {
    try {
      const actions = yield take(
        actionsCreator.getProductInfoById.type
      );

      const res = yield call(api.request, "getProductDrugInfoById", actions.payload);

      if (!res?.ok) {
        yield put(actionsCreator.getProductInfoByIdError());
      } else {
        yield put(actionsCreator.getProductInfoByIdSuccess(res.data));
      }
    } catch (e) {
      console.log("CATCH ERROR getProductInfoWatcher: ", e);
    }
  }
}
